import React, {
    useCallback, useContext, useEffect, useMemo, useRef,
} from 'react';
import {
    useMutation, useQuery, gql, useReactiveVar,
} from '@apollo/client';
// @ts-ignore
import cookies from 'js-cookie';

import { STORE_ENV_DATA } from 'app/graphql/network/envDataMutation';
import {
    abTestDataContext,
} from 'app/containers/contexts/abTest.context';
import { selectedPeriodVar } from 'app/apollo/reaction';

import { analyticService } from 'global/services';
import { idGenerator } from '../classes/uniqueIdGenerator';

// ХУК ВЫПОЛНЯЕТ ОДИН ИЗ ДВУХ ХЭНДЛЕРОВ В ЗАВИСИМОСТИ ОТ ТОГО, НА КАКУЮ СТРАНИЦУ ЗАШЕЛ ПОЛЬЗОВАТЕЛЬ

const USER_QUERY_FOR_AB_GROUPS = gql`
        query USER_QUERY_FOR_AB_GROUPS {
            user {
                id
                ab_groups
            }
        }
`;

const PARTICIPANT_ID_COOKIE_KEY = 'ab_participant_id';

const getOrCreateParticipantId = (): string => {
    let participantId = cookies.get(PARTICIPANT_ID_COOKIE_KEY);

    if (!participantId) {
        participantId = idGenerator.generateId();
        cookies.set(PARTICIPANT_ID_COOKIE_KEY, participantId, { expires: 365 });
    }

    return participantId;
};

// BR-1170
export const useTestLPDefine = (
    realm: 'target' | 'rest',
    nodeId: string,
    testName: string,
    selfExecutable: boolean = true,
) => {
    const mainBannerRootNode: HTMLElement | null = document.querySelector(`#${nodeId}`);
    const templateABTestValue = mainBannerRootNode?.dataset.ab_test_value;

    const isABTestValueSet = useRef(false);
    const period = useReactiveVar(selectedPeriodVar);
    const [storeEnvData] = useMutation(STORE_ENV_DATA);
    const { fetchABTestValue, setABTestValue } = useContext<any>(abTestDataContext);

    const data = useQuery(USER_QUERY_FOR_AB_GROUPS, {
        fetchPolicy: 'cache-only',
    }) || {};

    const user = data?.data?.user;

    const participantId = useMemo(() => getOrCreateParticipantId(), []);

    const isUserInABTestAlready = useMemo(
        () => {
            const testValueFromCookie = cookies.get(testName?.toUpperCase());
            return user?.ab_groups.includes(testName) || testValueFromCookie !== undefined;
        },
        [user, testName],
    );

    const handleSetAbTestValue = useCallback(
        () => {
            setABTestValue(testName, templateABTestValue);
            cookies.set(testName?.toUpperCase(), templateABTestValue, { expires: 30 });
            analyticService.push({
                eventName: 'Start_test',
                userId: user?.id,
                participantId,
                testName,
            });
        },
        [setABTestValue, templateABTestValue, testName, user?.id, participantId],
    );

    const handleCheckAndSetTest = useCallback(
        () => {
            if (!setABTestValue || isABTestValueSet?.current || !period) return;
            const isABTestValueFromTemplateToSet = Boolean(templateABTestValue) && !isUserInABTestAlready;
            console.log(templateABTestValue, 'templateABTestValue');
            if (isABTestValueFromTemplateToSet) {
                const variables = {
                    abGroup: `${testName}__${templateABTestValue}`,
                    period,
                    participantId,
                };
                storeEnvData({ variables }).then(
                    () => {
                        handleSetAbTestValue();
                    },
                );
            }
        },
        [
            setABTestValue, period, testName,
            isUserInABTestAlready, templateABTestValue,
            handleSetAbTestValue, storeEnvData, participantId,
        ],
    );

    const handleCheckAndTestValue = useCallback(
        () => {
            if (!fetchABTestValue || !period) return;

            const ABTestValueFromCookie = cookies.get(testName.toUpperCase());
            const isABTestNotFetched = ABTestValueFromCookie === undefined;

            if (isABTestNotFetched) {
                fetchABTestValue(testName).then((testValue: string) => {
                    if (testValue) {
                        cookies.set(testName?.toUpperCase(), testValue, { expires: 30 });
                    }
                });
                const variables = {
                    period,
                    participantId,
                };
                storeEnvData({ variables });
            }
        },
        [fetchABTestValue, testName, participantId, period, storeEnvData],
    );

    const getActionToExecute = useCallback(
        () => {
            const actionsByRealm = {
                target: handleCheckAndSetTest,
                rest: handleCheckAndTestValue,
            };
            return actionsByRealm[realm];
        },
        [handleCheckAndSetTest, handleCheckAndTestValue, realm],
    );

    useEffect(
        () => {
            if (!selfExecutable) return;
            const abTestHandler = getActionToExecute();
            abTestHandler();
            isABTestValueSet.current = true;
        },
        [getActionToExecute, selfExecutable],
    );

    return [getActionToExecute];
};
